module.exports = __webpack_public_path__ + "static/media/logo.7a5d5c3b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logo.png
 ** module id = 164
 ** module chunks = 0
 **/